import { ListLabel } from './videos/ui/ListLabel.tsx'
import type { TikTokContentListType } from './videos/ui/types'

export const getListsOptions = (lists: TikTokContentListType[]) => {
  return lists.map((list) => ({
    value: String(list.id),
    label: <ListLabel list={list} />,
  }))
}
